import React from 'react'
import { TxnBadge } from '@src/types/graphql-types'
import { makeStyles } from '@material-ui/core/styles'
import { Theme, Tooltip, TooltipProps, Typography } from '@material-ui/core'
import LabelChip from '@src/components/LabelChip'
import clsx from 'clsx'

const useStyles = makeStyles((theme: Theme) => ({
  promoChip: {
    '& .MuiChip-root': {
      backgroundColor: theme.palette.promoGreen,
      height: '26px',
    },
  },
  clickableChip: {
    '& .MuiChip-root': {
      cursor: 'pointer',
    },
  },
  promoChipLabel: {
    fontSize: theme.typography.pxToRem(12),
    fontWeight: theme.typography.fontWeightMedium,
  },
  tooltip: {
    backgroundColor: theme.palette.common.white,
    width: theme.typography.pxToRem(320),
    fontSize: theme.typography.pxToRem(16),
    boxShadow: '0 4px 6px 0 rgba(0, 0, 0, 0.16)',
    padding: theme.spacing(2, 4, 4),
    top: '10px',
    [theme.breakpoints.down('sm')]: {
      top: '0',
      right: '10px',
    },
    [theme.breakpoints.down('xs')]: {
      top: '0',
      right: '20px',
      width: '10rem',
    },
  },
  tooltipWrapper: {
    display: 'inline-block',
  },
  arrow: {
    color: theme.palette.common.white,
    fontSize: theme.typography.pxToRem(15),
    '&::before': {
      boxShadow: '0px 0px 2px rgba(0,0,0,0.2)',
    },
  },
  promoTitle: { fontSize: theme.typography.pxToRem(14) },
}))

const PROMO_MESSAGE = 'Up to 25% Off'
const PROMO_TOOLTIP_MESSAGE =
  'Save 25% off certain sizes to celebrate 50 years of the Sigma-Aldrich® brand. Offer ends September 26.'

interface TxnBadgeProps {
  txnBadge?: TxnBadge
  showTooltip?: boolean
  toolTipPlacement?: TooltipProps['placement']
}

const TxnBadge: React.FC<TxnBadgeProps> = ({
  showTooltip = false,
  toolTipPlacement = 'top',
}) => {
  const classes = useStyles()

  const tooltipContent = (
    <Typography className={classes.promoTitle}>
      {PROMO_TOOLTIP_MESSAGE}
    </Typography>
  )

  const labelChip = (
    <LabelChip
      label={
        <Typography className={classes.promoChipLabel}>
          {PROMO_MESSAGE}
        </Typography>
      }
      className={clsx(classes.promoChip, {
        [classes.clickableChip]: showTooltip,
      })}
    />
  )

  return (
    <>
      {showTooltip ? (
        <Tooltip
          arrow
          classes={{
            tooltip: classes.tooltip,
            arrow: classes.arrow,
          }}
          placement={toolTipPlacement}
          interactive
          title={tooltipContent}
          enterTouchDelay={0}
        >
          <div className={classes.tooltipWrapper}>{labelChip}</div>
        </Tooltip>
      ) : (
        labelChip
      )}
    </>
  )
}

export default TxnBadge
